import React from "react";
import { ArrowRight, CircleDot } from "lucide-react";

export const FinalLandingSection: React.FC = () => {
  const openRoute = (route: string) => window.location.assign(route);

  return (
    <>
      <section className="landing-finale landing-reveal-section">
        <div className="landing-finale__inner">
          <div className="landing-finale__eyebrow">
            <span className="landing-section-kicker">[ The next move ]</span>
            <span className="landing-finale__status"><i /> Observatory ready</span>
          </div>
          <div className="landing-finale__grid">
            <div className="landing-finale__copy">
              <h2>Stop guessing<br /><em>Start navigating</em></h2>
              <p>The planets do not control your destiny. They establish the dimensional terrain across which your decisions unfold.</p>
              <div className="landing-finale__actions">
                <button type="button" onClick={() => openRoute("/observatory")} className="landing-button landing-button--primary">
                  Enter the Observatory
                  <ArrowRight aria-hidden="true" />
                </button>
                <button type="button" onClick={() => document.getElementById("chart")?.scrollIntoView({ behavior: "smooth" })} className="landing-button landing-button--outline">
                  Generate a free chart
                </button>
              </div>
            </div>
            <div className="landing-finale__trajectory" aria-label="NEX operating sequence">
              <div className="landing-finale__trajectory-header">
                <span>NEX / operating sequence</span>
                <small>Ready when you are</small>
              </div>
              <div className="landing-finale__trajectory-line" aria-hidden="true"><i /><i /><i /><i /></div>
              <ol>
                <li><b>01</b><span><strong>Observe</strong><small>See the active field</small></span></li>
                <li><b>02</b><span><strong>Place</strong><small>Add the world around you</small></span></li>
                <li><b>03</b><span><strong>Act</strong><small>Choose the next move</small></span></li>
                <li><b>04</b><span><strong>Record</strong><small>Keep what you learn</small></span></li>
              </ol>
            </div>
          </div>
          <div className="landing-finale__proof"><span>Instant access</span><i /><span>Runs in any modern browser</span><i /><span>No cost to explore</span></div>
        </div>
      </section>
      <footer className="landing-footer">
        <div className="landing-footer__brand"><CircleDot aria-hidden="true" /><span>NEX Astro Observatory</span><small>© 2026</small></div>
        <nav className="landing-footer__links" aria-label="Footer navigation">
          <button type="button" onClick={() => openRoute("/methodology")}>Methodology</button>
          <button type="button" onClick={() => openRoute("/commons")}>Commons</button>
          <button type="button" onClick={() => openRoute("/privacy")}>Privacy</button>
          <button type="button" onClick={() => openRoute("/terms")}>Terms</button>
        </nav>
      </footer>
    </>
  );
};
